const getCurrentUser = () => atob(localStorage.getItem('user-endpoint'));

export default getCurrentUser;